
import * as Geolocation from './geolocation';
export default class Login {

    constructor() { this.bindLoginStuff(); }

   
    bindLoginStuff() {
        var self = this;
        // Trigger on click or on enter
        $("#login-button").click(()=>{               
            self.submit();
        });
        $("input[name='password']").on('keypress', (event)=>{              
            if (event.which === 13) {     
                self.submit();
            }
        });
        $("input[name='username']").on('keypress', (event)=>{              
            if (event.which === 13) {     
                self.submit();
            }
        });
    }

    submit() {               
        
        let action = $("#login-form").attr('action');   
        let username = $("input[name='username']").val();
        let password = $("input[name='password']").val();            
        let twofa = $("input[name='towfa']").val();    
        let message_container = $(".message-container");
        let csrf_token = $("meta[name='csrf_token']").attr('content');

        let appCodeName = navigator.appCodeName;
        let product = navigator.product;
        let platform = navigator.platform;
        let appVersion = navigator.appVersion;

        if (!twofa) { 

            $(message_container).html("Two factor authentication required");


        } else {                       

            $.ajax({      
                type: 'POST',
                url: action,
                data: {
                    button: "submit",
                    username: username,
                    password: password,
                    twofa: twofa,
                    platform: platform,
                    appVersion: appVersion,
                    csrf_token: csrf_token
                },
                beforeSend: function() {               
                    $("#loader_container").show();
                    $("#login-button").hide();
                },
                success: function(response) {     
                    // console.log(response);                                   
                    let jresponse = $.parseJSON(response);    
                    if (jresponse.status) {                     
                        Geolocation.geolocate()
                        .done(function(response) {           
                            var jresponse = jQuery.parseJSON(response);                                          
                            if (jresponse.location.city) {
                                Geolocation.storeAndCheckLoginZone(jresponse)
                                .done(function() {                                     
                                    location.reload(); 
                                })
                                .fail(function() {console.log("Store and Check Login Zone Failed");});
                            }
                        })
                        .fail(function() {console.log("Geolocation failed");});
                    } else {
                        // Show error message
                        $(message_container).html("Your credentials are invalid");
                        $("#loader_container").hide();
                        $("#login-button").show();
                    }                     
                
                },
            });
        }

    }

}